/* bl-blog-track.js — Verhaltens-Tracking für Blog-Übersicht + Blog-Artikel (Muster: bl-cf-rec.js).
 *
 * Beantwortet: Welche Rubriken/Themen interessieren, wie tief wird gelesen, wohin klicken die Leute
 * danach (Produkt, Weiterlesen, Clean Facts, Kollektion, Newsletter) – und welche Sessions kaufen.
 *
 * Alle Events tragen bl_seite (index|artikel), bl_artikel, bl_rubrik, bl_format, bl_dwell (s), bl_scroll (%).
 * Übersicht:  bl_blog_filter (bl_wert = Rubrik) · bl_blog_sort (bl_wert) · bl_blog_search (bl_wert = Begriff, bl_n = Treffer)
 *             bl_blog_card_click (bl_ziel = Handle, bl_pos = Position, bl_badge = neu|beliebt|-)
 * Artikel:    bl_blog_read (ab 30 s oder 50 % Scroll, einmal) · bl_blog_scroll (25/50/75/100, je einmal)
 *             bl_blog_toc_click · bl_blog_faq_open · bl_blog_related_click (bl_ziel) · bl_blog_cf_click (bl_ziel)
 *             bl_blog_link_click (bl_ziel = URL) · bl_blog_exit (Bilanz)
 * Produktblock: wird bereits von bl-cf-rec.js erfasst (bl_cf_impression / bl_cf_click, platz=block).
 * Kaufzuordnung: sessionStorage bl_blog_touch (letzter gelesener Artikel) → wird als bl_touch an jedes
 *             bl_blog_* Event gehängt; in GA4 als Segment „Sessions mit bl_blog_read“ gegen purchase auswerten.
 */
(function () {
  'use strict';
  if (window.__blBlogInit) return;
  var index = document.querySelector('.blb-index');
  var art = document.querySelector('.blb-article');
  if (!index && !art) return;
  window.__blBlogInit = true;

  var t0 = Date.now(), maxScroll = 0, read = false, marks = {}, clicks = [];
  var ctx = art ? art.querySelector('[data-bl-cf-ctx]') : null;
  var A = {
    seite: art ? 'artikel' : 'index',
    artikel: ctx ? (ctx.dataset.blArticle || '') : (art ? location.pathname.split('/').pop() : ''),
    rubrik: (art || index) ? ((art || index).className.match(/blb-rub--([a-z]+)/) || [,''])[1] : '',
    format: art ? ((art.querySelector('.blb-fmtl') || {}).textContent || '').trim() : ''
  };
  function sek() { return Math.round((Date.now() - t0) / 1000); }
  function touch() { try { return sessionStorage.getItem('bl_blog_touch') || ''; } catch (e) { return ''; } }
  function track(name, p) {
    if (window.blIntern) return;
    var d = Object.assign({ bl_seite: A.seite, bl_artikel: A.artikel, bl_rubrik: A.rubrik, bl_format: A.format,
      bl_dwell: sek(), bl_scroll: maxScroll, bl_touch: touch() }, p || {});
    try { if (typeof window.gtag === 'function') window.gtag('event', name, d); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, d)); } catch (e) {}
  }
  function scrollPct() {
    var h = document.documentElement, s = window.scrollY || h.scrollTop, m = h.scrollHeight - innerHeight;
    return m > 0 ? Math.min(100, Math.round(s / m * 100)) : 100;
  }
  window.addEventListener('scroll', function () {
    var p = scrollPct(); if (p > maxScroll) maxScroll = p;
    if (art) {
      [25, 50, 75, 100].forEach(function (m) { if (p >= m && !marks[m]) { marks[m] = 1; track('bl_blog_scroll', { bl_wert: m }); } });
      if (!read && p >= 50) { read = true; track('bl_blog_read', { bl_grund: 'scroll' });  try { if (window.blHerkunft) window.blHerkunft.merke(); } catch (e) {} }
    }
  }, { passive: true });
  if (art) {
    setTimeout(function () { if (!read) { read = true; track('bl_blog_read', { bl_grund: 'zeit' });  try { if (window.blHerkunft) window.blHerkunft.merke(); } catch (e) {} } }, 30000);
    try { sessionStorage.setItem('bl_blog_touch', A.artikel); } catch (e) {}
  }

  /* ---------- Übersicht ---------- */
  if (index) {
    var lastTerm = '', tSearch;
    index.addEventListener('click', function (e) {
      var ch = e.target.closest('[data-blb-cat]'); if (ch) { track('bl_blog_filter', { bl_wert: ch.dataset.blbCat }); return; }
      var s = e.target.closest('[data-blb-sort]'); if (s) { track('bl_blog_sort', { bl_wert: s.dataset.blbSort }); return; }
      var c = e.target.closest('.blb-card'); if (c) {
        var cards = Array.prototype.filter.call(index.querySelectorAll('.blb-card'), function (x) { return !x.hidden; });
        var badge = c.querySelector('.blb-badge--neu') ? 'neu' : (c.querySelector('.blb-badge') ? 'beliebt' : '-');
        track('bl_blog_card_click', { bl_ziel: (c.getAttribute('href') || '').split('/').pop(), bl_rubrik: c.dataset.cat || '',
          bl_pos: cards.indexOf(c) + 1, bl_badge: badge, bl_filter: index.dataset.cat, bl_sort: index.dataset.sort });
      }
    });
    var q = index.querySelector('[data-blb-q]');
    if (q) q.addEventListener('input', function () {
      clearTimeout(tSearch);
      tSearch = setTimeout(function () {
        var v = q.value.trim().toLowerCase(); if (v.length < 3 || v === lastTerm) return; lastTerm = v;
        var n = Array.prototype.filter.call(index.querySelectorAll('.blb-card'), function (x) { return !x.hidden; }).length;
        track('bl_blog_search', { bl_wert: v, bl_n: n });
      }, 900);
    });
  }

  /* ---------- Artikel ---------- */
  if (art) {
    art.addEventListener('click', function (e) {
      var a = e.target.closest('a'); if (!a) return;
      var href = a.getAttribute('href') || '';
      if (a.closest('[data-blb-toc]')) { clicks.push('toc'); track('bl_blog_toc_click', { bl_ziel: href }); return; }
      if (a.closest('.blb-more .blb-card')) { clicks.push('related'); track('bl_blog_related_click', { bl_ziel: href.split('/').pop() }); return; }
      if (a.classList.contains('blb-cfrow')) { clicks.push('cf'); track('bl_blog_cf_click', { bl_ziel: href.split('/').pop() }); return; }
      if (a.classList.contains('blb-link') || a.classList.contains('blb-all')) { clicks.push('link'); track('bl_blog_link_click', { bl_ziel: href }); return; }
      if (a.closest('.blb-body') && !a.closest('.bl-cf')) { clicks.push('inline'); track('bl_blog_link_click', { bl_ziel: href, bl_platz: 'inline' }); }
    });
    art.addEventListener('toggle', function (e) {
      var d = e.target; if (d.tagName === 'DETAILS' && d.open && d.closest('.blb-faq')) track('bl_blog_faq_open', { bl_wert: (d.querySelector('summary') || {}).textContent || '' });
    }, true);
    var exitSent = false;
    function exit() { if (exitSent) return; exitSent = true; track('bl_blog_exit', { bl_gelesen: read ? 1 : 0, bl_klicks: clicks.join(',') || '-' }); }
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') exit(); });
    window.addEventListener('pagehide', exit);
  }
})();
